import axios from "axios";
import { type IDomainsDataService } from "../types/services";
import { type AddDomainToAccountRequest } from "../types/requests";
import {
  type AccountDomain,
  type AvailableDomainsConfiguration,
  type AvailableDomainsPoolsConfiguration,
} from "../types/state";
import { type DistributedOperationResult } from "types";

const threatDefenceUrl = "/api/v2/threat-defence";

const instance: IDomainsDataService = {
  addDomainToAccountsAsync: async (request: AddDomainToAccountRequest) => {
    const response = await axios.post<DistributedOperationResult>(`${threatDefenceUrl}/domains/accounts`, request);
    return response.data;
  },
  getAccountAvailableDomainsAsync: async (accountId: number) => {
    const response = await axios.get<AvailableDomainsConfiguration>(
      `${threatDefenceUrl}/domains/accounts/${accountId}/available-domains`,
    );
    return response.data;
  },
  getAccountAvailableDomainPoolsAsync: async () => {
    const response = await axios.get<AvailableDomainsPoolsConfiguration>(
      `${threatDefenceUrl}/domain-pools/accounts/domains`,
    );
    return response.data;
  },

  getAccountDomainAsync: async (accountId: number) => {
    const response = await axios.get<AccountDomain>(`${threatDefenceUrl}/domains/account/${accountId}/domain`);
    return response.data;
  },
};

export default instance;
